<template>
	<footer class="footer">
		<span>© {{year}} K. G. Joner</span>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
	data: function() {
		return {
			year: new Date().getFullYear()
		}
	}
}
</script>

<style>

.footer {
	grid-area: footer;
	background-color: #333;
	width: 100vw;

	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.footer span {
	color: #f2f2f2;
	margin-left: 20px;
	font-size: 0.8rem;
}

</style>
